module.exports = __webpack_public_path__ + "img/DCIImg08.5f8df31a.png";